import React, { FC } from 'react';

import { HarvestSummaryTabProps } from './HarvestSummary.props';

import HarvestSummaryTabContent from './HarvestSummaryTabContent';
import { InventoryReportStatusEnum } from 'types/report';
const ReadyForInvoiceSummary: FC<HarvestSummaryTabProps> = (props) => {
  const { counts, ...data } = props;
  const filteredCounts = counts.filter(
    (count) => count.status === InventoryReportStatusEnum.READY_FOR_INVOICE,
  );

  return <HarvestSummaryTabContent counts={filteredCounts} {...data} />;
};

export default ReadyForInvoiceSummary;
